export const concatClassNames = (props, styles) =>
  Object.entries(styles)
    .filter(([key]) => props.hasOwnProperty(key))
    .map(([key, value]) => value)
    .join(" ");
